import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1","key":"svg-0"}],["path",{"d":"M14 8h-2m-2 2v6h4","key":"svg-1"}],["path",{"d":"M10 12h2","key":"svg-2"}],["path",{"d":"M17 8h4","key":"svg-3"}],["path",{"d":"M19 8v7","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconHttpGetOff = createReactComponent('outline', 'http-get-off', 'HttpGetOff', __iconNode);

export default IconHttpGetOff;